/**
 * Badge component
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// CSS Style for this module
import styles from './badge.module.scss';

/**
 * Interface for Badge props
 */
interface BadgeProps {
	/**
	 * The target item that will have the badge
	 */
	children: React.ReactNode;
	/**
	 * Label of the badge
	 */
	label: string | number | React.ReactElement;
	/**
	 * Styling & Positioning of the badge
	 */
	customStyles?: string;
}

/**
 * Badge generates a small badge to the top-right of its child(ren).
 * @param {BadgeProps} Prop
 * @returns  an element with the badge attached to it
 */
export const Badge = ({ children, label, customStyles }: BadgeProps) => {
	return (
		<>
			<div className={styles.badgeContainer}>
				<div className={[styles.badge, customStyles].join(' ')}>{label as React.ReactNode}</div>
				{children}
			</div>
		</>
	);
};
